import type { PropsWithChildren } from 'react';
import cn from '@/utils/merge-class-names';
import type { BaseIconProps } from './icon.type';

const Icon = ({ className, selected = false, children, ...props }: PropsWithChildren<BaseIconProps>) => {
  return (
    <div
      className={cn(
        'flex size-10 items-center justify-center',
        selected ? 'text-gray-600' : ' text-gray-400 hover:text-gray-600',
        className,
      )}
      {...props}>
      {children}
    </div>
  );
};

export default Icon;
